import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import CommunitypageBanner from './community-banner';

import CommunityProjects from './community-projects'; 
 

function CommunityPage () {
    return(
      <Fragment> 
      <Header />  
      <CommunitypageBanner /> 
      <CommunityProjects />
      <Footer /> 
      </Fragment> 
    );
}
export default CommunityPage;